<template>
  <ViewAndEdit
    v-if="operatorDefinition.value"
    v-model="selectedValueString"
    label="Value"
    mode="edit"
    :attributes="attributes"
    @update:model-value="onValueChange"
  />
</template>

<script setup lang="ts">
import type { WorkflowDefinitionConditionOperatorEntity } from '@/api/entity_types/workflow/WorkflowDefinition';
import ViewAndEdit from '../common/ViewAndEdit.vue';
import { useConditionValue } from './useConditionValue';
import type { WorkflowExpressionCondition } from '@/api/entity_types/workflow/WorkflowCondition';

export type ConditionValueProps = {
  operatorDefinition: WorkflowDefinitionConditionOperatorEntity;
  selectedOperator: string;
  selectedProperty: string;
  expressionCondition: WorkflowExpressionCondition;
  index: number;
};

const props = defineProps<ConditionValueProps>();
const { selectedValueString, attributes, onValueChange } = useConditionValue(props);
</script>
